module.exports = __webpack_public_path__ + "media/images/global/arrow-left-ac6476deb211addf0161164a764c2640.svg";